import React from 'react'
import PropTypes from 'propTypes'

import { useMediaQuery } from '@offerzen/pinata-shame'
import NavDropdown, { DropdownHeader, DropdownButton } from '../NavDropdown'
import styles from './styles'

const NavToggle = ({ activeHiringTeam, hiringTeams, onItemClick }) => {
  const { isDesktopOrLarger } = useMediaQuery()

  return (
    <div className={styles.wrapper}>
      <If condition={isDesktopOrLarger}>
        <span>Team:</span>
      </If>
      <NavDropdown label={activeHiringTeam.name} className={styles.dropdown}>
        <DropdownHeader text="Switch to another hiring team" />
        <For each="team" of={hiringTeams}>
          <DropdownButton key={team.id} label={team.name} onClick={() => onItemClick(team.id)} active={activeHiringTeam.id === team.id} />
        </For>
      </NavDropdown>
    </div>
  )
}

NavToggle.propTypes = {
  activeHiringTeam: PropTypes.shape({
    id: PropTypes.string,
    name: PropTypes.string,
  }),
  hiringTeams: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string,
      name: PropTypes.string,
    }),
  ),
  onItemClick: PropTypes.func,
}

export default NavToggle
